import React from 'react';
import '../../../css/gardenManagerStylings/journalSection/JournalEntryStyling.css';

const JournalEntryComponent = ({ journalEntry }) => {

    return (
        <div className={`journal-entry-preview`} key={journalEntry.id}>
            <div className={`journal-entry-preview-title-and-date`}>
                <div className={`journal-entry-preview-title`}>
                    {journalEntry.title}
                </div>
                <div className={`journal-entry-preview-date`}>
                    {new Date(journalEntry.created_at).toLocaleString('en-US', {
                        year: 'numeric',
                        month: 'short',
                        day: 'numeric',
                        hour: '2-digit',
                        minute: '2-digit'
                    })}
                </div>
            </div>

            <div className={`journal-entry-preview-content`}>
                {journalEntry.content}
            </div>
        </div>
    )
}

export default JournalEntryComponent;